import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

class Icon extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      width: null,
      height: null,
      content: null,
    }
  }

  componentDidMount() {
    const { name } = this.props

    import(`assets/img/icons/${name}.svg`).then((svg) => {
      this.setState({
        xmlns: svg.attributes.xmlns,
        width: svg.attributes.width,
        height: svg.attributes.height,
        viewBox: svg.attributes.viewBox,
        content: svg.content,
      })
    })
  }

  render() {
    const { xmlns, width, height, viewBox, content } = this.state
    const { className, color } = this.props

    return (
      <span className={className}>
        {content && (
          <svg
            xmlns={xmlns}
            width={width}
            height={height}
            viewBox={viewBox}
            color={color}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </span>
    )
  }
}

Icon.propTypes = {
  name: PropTypes.oneOf([
    'attention',
    'accident',
    'add',
    'aide',
    'alert',
    'arrow',
    'arrow-right',
    'back',
    'boxes',
    'calendar',
    'check-icon',
    'clockpicker',
    'close',
    'compte',
    'congratulations',
    'course',
    'course-terminee',
    'courses-archivees',
    'coursier',
    'coursiers',
    'dashboard',
    'deconnexion',
    'demande-terminee',
    'dropdown',
    'email',
    'embouteillage',
    'handshake',
    'immobilisation',
    'informations',
    'kilometres',
    'localisation-delivery',
    'location',
    'logo-glinko-white',
    'mail-confirmation',
    'marchandise',
    'mail',
    'menu',
    'parametres',
    'password',
    'pending-delivery',
    'phone',
    'recapitulatif',
    'recette',
    'search',
    'shape',
    'signalement-probleme',
    'societe',
    'status',
    'travaux',
    'trash',
    'vehicule',
    'tel',
    'twitter',
    'linkedin',
    'ecmr',
    'cmr',
    'star',
    'flag',
    'edit',
    'delete',
    'cut',
    'forklift',
    'truck',
    'grand-displacement',
    'box',
    'dinner',
    'lunch',
    'breakfast',
    'pen',
    'clock',
    'timer-off',
  ]),
  className: PropTypes.string,
  color: PropTypes.string,
}

export default Icon
